// Auto-generated TypeScript enum from PHP enum

export type StripeCurrency = 'aed' | 'ars' | 'aud' | 'brl' | 'cad' | 'chf' | 'clp' | 'cny' | 'cop' | 'czk' | 'dkk' | 'eur' | 'gbp' | 'hkd' | 'idr' | 'ils' | 'inr' | 'jpy' | 'krw' | 'mxn' | 'myr' | 'nok' | 'nzd' | 'pen' | 'php' | 'pln' | 'sar' | 'sek' | 'sgd' | 'thb' | 'twd' | 'usd' | 'zar';

export const StripeCurrency = {
  AED: 'aed' as const,
  ARS: 'ars' as const,
  AUD: 'aud' as const,
  BRL: 'brl' as const,
  CAD: 'cad' as const,
  CHF: 'chf' as const,
  CLP: 'clp' as const,
  CNY: 'cny' as const,
  COP: 'cop' as const,
  CZK: 'czk' as const,
  DKK: 'dkk' as const,
  EUR: 'eur' as const,
  GBP: 'gbp' as const,
  HKD: 'hkd' as const,
  IDR: 'idr' as const,
  ILS: 'ils' as const,
  INR: 'inr' as const,
  JPY: 'jpy' as const,
  KRW: 'krw' as const,
  MXN: 'mxn' as const,
  MYR: 'myr' as const,
  NOK: 'nok' as const,
  NZD: 'nzd' as const,
  PEN: 'pen' as const,
  PHP: 'php' as const,
  PLN: 'pln' as const,
  SAR: 'sar' as const,
  SEK: 'sek' as const,
  SGD: 'sgd' as const,
  THB: 'thb' as const,
  TWD: 'twd' as const,
  USD: 'usd' as const,
  ZAR: 'zar' as const,
} as const;

export const StripeCurrencyUtils = {
  values: Object.values(StripeCurrency),
  keys: Object.keys(StripeCurrency) as Array<keyof typeof StripeCurrency>,
  entries: Object.entries(StripeCurrency) as Array<[keyof typeof StripeCurrency, StripeCurrency]>,
  isValid: (value: any): value is StripeCurrency => Object.values(StripeCurrency).includes(value),
  fromKey: (key: keyof typeof StripeCurrency): StripeCurrency => StripeCurrency[key],
};

